import { render, staticRenderFns } from "./jindieextra.vue?vue&type=template&id=da2c5c68&scoped=true&"
import script from "./jindieextra.vue?vue&type=script&lang=js&"
export * from "./jindieextra.vue?vue&type=script&lang=js&"
import style0 from "./jindieextra.vue?vue&type=style&index=0&id=da2c5c68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2c5c68",
  null
  
)

export default component.exports